import React from 'react'
import {
  RailsIcon,
  WheelIcon,
  ProfileIcon,
  TorqueIcon,
  EuIcon,
  ColoursIcon,
  WrenchIcon,
  TrophyIcon,
} from './icons'

// Shared, single-source-of-truth data + icons for the GT-2 comparison table.
// Baked in here (not the dataset) because the exact same table renders on BOTH
// the /hardware/gt2-cockpit marketing page (as a registered section) AND inside
// the /product/gt2-cockpit configurator island — keeping the copy in one place
// means one edit updates both surfaces. A dataset block / the configurator may
// still override `title`/`caption`/`vrsLabel`/`otherLabel`/`rows` via props.
//
// Every claim here must stay defensible (see the "Others" column = a generic,
// unnamed typical competitor, on purpose). No em/en dashes in any copy.

export const DEFAULT_EYEBROW = 'The GT-2 difference'
export const DEFAULT_TITLE = 'Why choose the VRS GT-2?'
export const DEFAULT_CAPTION = 'Everything a serious rig needs comes in the box. Here is how that stacks up.'
export const DEFAULT_VRS_LABEL = 'VRS GT-2'
export const DEFAULT_OTHER_LABEL = 'Typical competitor'

// NOTE (legal): the right-hand column compares against a TYPICAL competitor, not
// a named brand, so every cell is hedged ("often", "commonly", "varies") rather
// than stated as a universal fact. EU comparative-advertising rules
// (Dir. 2006/114/EC) require comparisons to be objective and verifiable; blanket
// claims about all competitors are not. Do not harden these back into absolutes
// without a substantiated, dated source per row.
export const DEFAULT_ROWS = [
  { Icon: RailsIcon, feature: 'Seat sliders', vrs: 'Included in the price', other: 'Commonly sold separately' },
  { Icon: RailsIcon, feature: 'Seat brackets', vrs: 'Included in the price', other: 'Commonly sold separately' },
  { Icon: WheelIcon, feature: 'Front or bottom wheelbase mount', vrs: 'Your choice, included', other: 'Sometimes an extra' },
  { Icon: ProfileIcon, feature: 'Aluminium profile', vrs: '160 x 40 mm, 3.5 mm wall', other: 'Often lighter thin-wall' },
  { Icon: TorqueIcon, feature: 'Direct drive support', vrs: 'Up to 45 Nm', other: 'Often rated lower' },
  { Icon: EuIcon, feature: 'Made in', vrs: 'European Union', other: 'Often imported' },
  { Icon: ColoursIcon, feature: 'Colour options', vrs: '7 colours', other: 'Often black only' },
  { Icon: WrenchIcon, feature: 'Assembly', vrs: '95% pre-assembled', other: 'Often flat-pack' },
  { Icon: TrophyIcon, feature: 'Raced by pros', vrs: 'Yes, Apex Racing', other: 'Rarely' },
]

export function CheckIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  )
}

export function DashIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="6" y1="12" x2="18" y2="12"/>
    </svg>
  )
}
